import { useQuery } from '@tanstack/react-query';

import * as dashboardApi from './dashboard.api';

import type { DashboardPeriod } from '@utazzo/shared';

const QK = {
  insights: (period: DashboardPeriod) => ['dashboard', 'insights', period] as const,
  websiteHealth: () => ['dashboard', 'website-health'] as const,
  websiteBreakdown: () => ['dashboard', 'website-breakdown'] as const,
  productsBreakdown: () => ['dashboard', 'products-breakdown'] as const,
};

export const useDashboardInsights = (period: DashboardPeriod = 'mtd') =>
  useQuery({
    queryKey: QK.insights(period),
    queryFn: () => dashboardApi.getDashboardInsights(period),
    staleTime: 30_000,
    refetchOnWindowFocus: false,
  });

/**
 * Single fetch behind the whole website-manager dashboard - tile counts,
 * the needs-attention card and the recently-edited feed all read from it.
 */
export const useWebsiteHealth = () =>
  useQuery({
    queryKey: QK.websiteHealth(),
    queryFn: () => dashboardApi.getWebsiteHealth(),
    staleTime: 60_000,
    refetchOnWindowFocus: false,
  });

/** The drill-down behind the tiles: per-destination matrix + per-surface splits. */
export const useWebsiteBreakdown = () =>
  useQuery({
    queryKey: QK.websiteBreakdown(),
    queryFn: () => dashboardApi.getWebsiteBreakdown(),
    staleTime: 60_000,
    refetchOnWindowFocus: false,
  });

/** Per-product "ready to quote" completeness across the six catalog masters. */
export const useProductsBreakdown = () =>
  useQuery({
    queryKey: QK.productsBreakdown(),
    queryFn: () => dashboardApi.getProductsBreakdown(),
    staleTime: 60_000,
    refetchOnWindowFocus: false,
  });
